export const validationSchema = {
    email: {type: 'isEmail', message: 'Please enter a valid email.'},
    password: {
        type: 'isEmpty',
        message: 'Please enter your password.',
    },
};
